import PouchDB from 'pouchdb';
import { AppCouchDBurl } from '../Constants/EnvConstants';
// const AppCouchDBurl = 'https://sandeep:Y1wX771auCNe@couchdb.spicy-tees.in/';

// Initialize PouchDB
const initializeDB = () => new PouchDB('myDatabase');
let db = initializeDB();
// Helper function to check if the database is destroyed and reinitialize if needed
const ensureDB = async () => {
  try {
    await db.info();
  } catch (error) {
    db = initializeDB();
  }
};

let manualUUID = null;
const getUUIDFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('uuid') || manualUUID;
};

const queue = [];
let isProcessing = false;

// this function will try to reattempt the queue with the given UUID within a same session (currently queue will store the data in memory if UUID is not available)
export const reattemptPouchdbQueue = async (uuid) => {
  manualUUID = uuid;
  return new Promise(async (resolve) => {
    await processQueue();
    resolve();
  });
};

const processQueue = async () => {
  if (isProcessing || queue.length === 0) return;
  isProcessing = true;

  while (queue.length > 0) {
    const { key, value, resolve, reject } = queue.shift();
    const uuid = getUUIDFromURL();
    if (!uuid) {
      // If UUID is not available, re-add the item to the queue and break the loop
      queue.unshift({ key, value, resolve, reject });
      console.log('UUID is not available, breaking queue loop');
      break;
    }
    try {
      resolve(await addDataToDB(key, value));
    } catch (error) {
      reject(error);
    }
  }

  isProcessing = false;
};

const addDataToDB = async (key, value) => {
  await resetDatabaseIfOtherUUIDExist();

  await ensureDB();
  const uuid = getUUIDFromURL();
  if (!uuid) {
    return;
  }
  try {
    const existingEntry = await db.get(uuid).catch(() => null);

    const newData = {
      _id: uuid,
      _rev: existingEntry ? existingEntry._rev : undefined,
      data: {
        ...(existingEntry?.data || {}),
        [key]: value,
      },
    };
    const response = await db.put(newData);
    return response.id;
  } catch (error) {
    console.error('Failed to add data: ' + error.message);
  }
};

// main function to add data to PouchDB
export const AddPouchDBData = (key, value) =>
  new Promise((resolve, reject) => {
    queue.push({ key, value, resolve, reject });
    processQueue();
  });

export const GetPouchDBData = async (key) => {
  const uuid = getUUIDFromURL();
  if (!key) {
    console.error('Key is required to fetch the data.');
  }
  await ensureDB();
  if (!uuid) {
    return null;
  }
  try {
    const doc = await db.get(uuid);
    if (doc.data && typeof doc.data === 'object') {
      return doc.data[key] !== undefined ? doc.data[key] : null;
    }
    return null;
  } catch (error) {
    return null;
  }
};
export const ClearAllPouchDBData = async () => {
  try {
    await ensureDB();
    await db.destroy();
    // db = initializeDB();
    return true;
  } catch (error) {
    console.error('Failed to clear database: ' + error.message);
  }
};

export const removeAllKeys = async () => {
  await ensureDB();
  const uuid = getUUIDFromURL();
  try {
    // Retrieve all documents in the database
    const allDocs = await db.allDocs({ include_docs: true });

    if (allDocs.rows.length === 0) {
      return;
    }

    // Filter docs to delete by UUID matching the _id
    const docsToDelete = allDocs.rows
      .filter((row) => row.doc._id === uuid) // Only select documents matching the UUID
      .map((row) => ({
        _id: row.id,
        _rev: row.doc._rev,
        _deleted: true,
      }));

    if (docsToDelete.length === 0) {
      return;
    }

    // Perform the bulk delete operation
    await db.bulkDocs(docsToDelete);
    console.log(`Documents with UUID: ${uuid} marked as deleted.`);
  } catch (error) {
    console.error('Error deleting documents with UUID:', error);
  }
};

export const resetDatabaseIfOtherUUIDExist = async () => {
  await ensureDB();
  const uuid = getUUIDFromURL();

  if (!uuid) {
    console.log('UUID is required to preserve data.');
    return;
  }

  try {
    // Fetch all documents in the database
    const allDocs = await db.allDocs({ include_docs: true });

    // Check if there are any documents that are not the current UUID
    const otherUUIDsExist = allDocs.rows.some((row) => row.id !== uuid);
    if (otherUUIDsExist) {
      // Destroy the current database
      await db.destroy();
      console.log(`Other UUIDs exist. Database has been destroyed.`);

      // Reinitialize the database
      db = initializeDB();
      initializeSync(uuid);
      console.log('Database reinitialized.');
    } else {
      initializeSync(uuid);
      console.log('Only current UUID exists. Database is kept as is.');
    }
  } catch (error) {
    console.error('Error resetting database:', error);
  }
};

// !! Below code is only for syncing purposes (write anything else above this line) !! //

// currentUUID will prevent multiple syncs for the same UUID
let currentUUID = null;
// initializeSync function will initialize sync with remote couch database
const initializeSync = (uuid) => {
  if (!uuid || uuid === currentUUID || !AppCouchDBurl) {
    return;
  }
  currentUUID = uuid;
  console.log('Initializing sync for UUID:', uuid);

  const remoteDB = new PouchDB(AppCouchDBurl + 'cmhr109_test');

  // Pull only the document with the given UUID (including deletions)
  db.replicate.from(remoteDB, {
    live: true,
    retry: true,
    selector: {
      _id: uuid, // Only sync this document
    },
  });
  // Push only the document with the given UUID (excluding deletions)
  db.replicate.to(remoteDB, {
    live: true,
    retry: true,
    filter: (doc) => doc._id === uuid && !doc._deleted, // Do not push deleted docs
  });
};

// Initialize sync on website load if UUID is present in the URL
const uuid = getUUIDFromURL();
if (uuid) {
  ensureDB().then(async () => {
    try {
      const allDocs = await db.allDocs({ include_docs: true });
      if (allDocs.rows.length === 0) {
        initializeSync(uuid);
        console.log('Database available, initializing sync on page load.');
      } else {
        console.log(
          'Database is not empty, skipping sync initialization on page load.'
        );
      }
    } catch (error) {
      console.log('Error checking database, initializing sync on page load.');
      initializeSync(uuid);
    }
  });
}
